AFRAME.registerComponent("loading-strategy", {
  schema: {
    strategy: { type: "string", default: "eager" }
  }
});
